import { resolveMediaUrl as resolveSharedMediaUrl } from "../shared/media";
import { apiGet, apiPut } from "./client";

const BRAND_KEY = "platform_brand_v1";

export const DEFAULT_PLATFORM_BRAND = {
  name: "SkillUpIQ",
  logo_url: "",
  hero_image_url: "",
  hero_tagline: "",
  about:
    "منصة تعليمية عربية تقدم اشتراكًا شهريًا للوصول إلى المحتوى التدريبي والمهام والتقييمات ضمن تجربة منظمة وواضحة.",
  terms:
    "باستخدام المنصة فأنت تقر بصحة بياناتك ومسؤوليتك عن حماية حسابك وعدم مشاركته مع أي طرف آخر.\nيقتصر استخدام المحتوى والاختبارات والمهام على التعلم الشخصي داخل المنصة، ويمنع النسخ أو إعادة البيع أو إعادة النشر دون موافقة مكتوبة.\nتعرض المنصة الخدمة والسعر ومدة الاشتراك قبل إتمام الطلب، ويعد إتمام التسجيل أو الاشتراك موافقة على السياسات المنشورة داخل المنصة.\nيحق للمنصة تعليق الحساب أو تقييد الوصول عند إساءة الاستخدام أو محاولة الإضرار بالمنصة أو بالمحتوى أو بحقوق المستخدمين الآخرين.\nتخضع العلاقة التعاقدية لأنظمة المملكة العربية السعودية، ويتم نشر أي تحديث جوهري على هذه السياسات داخل المنصة.",
  privacy_policy:
    "تجمع المنصة بيانات الحساب الأساسية مثل الاسم والبريد الإلكتروني ورقم الجوال، إضافة إلى بيانات الاستخدام والتعلم والاشتراك بالقدر اللازم لتشغيل الخدمة.\nتستخدم هذه البيانات لإدارة الحساب، وتقديم المحتوى، والتحقق من الهوية، ومعالجة الطلبات، وتحسين الدعم والجودة التشغيلية.\nلا تبيع المنصة البيانات الشخصية، ولا تشاركها إلا مع مزودي الخدمة اللازمين للتشغيل مثل الاستضافة والبريد والدفع وفي حدود الحاجة النظامية والتشغيلية.\nتتخذ المنصة إجراءات تقنية وتنظيمية مناسبة لحماية البيانات من الوصول غير المصرح به أو الاستخدام غير المشروع.\nيمكن للمستخدم طلب تحديث بياناته أو الاستفسار عن الخصوصية عبر قنوات التواصل المعتمدة داخل المنصة.",
  refund_policy:
    "تعرض المنصة الخدمة والسعر ومدة الاشتراك بوضوح قبل الدفع.\nلأن الخدمة رقمية ويبدأ الانتفاع بها عند تفعيل الوصول، فلا يكون الاسترجاع متاحًا بعد تفعيل الاشتراك إلا إذا ثبت وجود تحصيل مكرر أو خطأ تقني من طرف المنصة أو عدم تفعيل الخدمة بعد السداد.\nتقدم طلبات المراجعة والاسترجاع عبر قنوات الدعم الموضحة داخل المنصة مع إرفاق بيانات الطلب، وتتم مراجعتها وفق الحالة المثبتة.",
  applied_system:
    "تخضع المنصة لأنظمة المملكة العربية السعودية ولوائحها ذات الصلة، ويُرجع في أي استخدام أو نزاع إلى الأنظمة والسياسات التشغيلية المعلنة داخل المنصة.",
  contact_label: "التواصل والدعم",
  contact_url: "",
  contact_desc: "لاستقبال الاستفسارات والشكاوى والملاحظات عبر القنوات الموضحة في المنصة.",
  support_email: "",
  support_phone: "",
};

const MOJIBAKE_RE = /[\u00C0-\u017F\u20AC\u2122\u201A-\u201E]/;

function recoverArabicText(value) {
  const text = String(value ?? "");
  if (!text || !MOJIBAKE_RE.test(text)) return text;

  try {
    const recovered = Buffer.from(text, "latin1").toString("utf8");
    return /[\u0600-\u06FF]/.test(recovered) ? recovered : text;
  } catch {
    return text;
  }
}

function normalizePlatformBrand(rawBrand) {
  const parsed = rawBrand && typeof rawBrand === "object" ? rawBrand : {};
  const legacyName = parsed.platform_name ?? parsed.platformName ?? "";
  const legacyAbout = parsed.about_text ?? parsed.aboutText ?? "";

  return {
    ...DEFAULT_PLATFORM_BRAND,
    name: recoverArabicText(
      (parsed.name || legacyName || DEFAULT_PLATFORM_BRAND.name).toString()
    ),
    logo_url: (parsed.logo_url || DEFAULT_PLATFORM_BRAND.logo_url).toString(),
    hero_image_url: (
      parsed.hero_image_url || DEFAULT_PLATFORM_BRAND.hero_image_url
    ).toString(),
    hero_tagline: recoverArabicText(
      (parsed.hero_tagline || DEFAULT_PLATFORM_BRAND.hero_tagline).toString()
    ),
    about: recoverArabicText(
      (parsed.about || legacyAbout || DEFAULT_PLATFORM_BRAND.about).toString()
    ),
    terms: recoverArabicText(
      (parsed.terms || DEFAULT_PLATFORM_BRAND.terms).toString()
    ),
    privacy_policy: recoverArabicText(
      (parsed.privacy_policy || DEFAULT_PLATFORM_BRAND.privacy_policy).toString()
    ),
    refund_policy: recoverArabicText(
      (parsed.refund_policy || DEFAULT_PLATFORM_BRAND.refund_policy).toString()
    ),
    applied_system: recoverArabicText(
      (parsed.applied_system || DEFAULT_PLATFORM_BRAND.applied_system).toString()
    ),
    contact_label: recoverArabicText(
      (parsed.contact_label || DEFAULT_PLATFORM_BRAND.contact_label).toString()
    ),
    contact_url: (
      parsed.contact_url || DEFAULT_PLATFORM_BRAND.contact_url
    ).toString(),
    contact_desc: recoverArabicText(
      (parsed.contact_desc || DEFAULT_PLATFORM_BRAND.contact_desc).toString()
    ),
    support_email: (parsed.support_email || DEFAULT_PLATFORM_BRAND.support_email).toString(),
    support_phone: (parsed.support_phone || DEFAULT_PLATFORM_BRAND.support_phone).toString(),
  };
}

export function resolveUploadsUrl(maybePath) {
  return resolveSharedMediaUrl(maybePath);
}

export const resolveMediaUrl = resolveUploadsUrl;

function cachePlatformBrand(nextBrand) {
  const safe = normalizePlatformBrand(nextBrand);
  localStorage.setItem(BRAND_KEY, JSON.stringify(safe));
  return safe;
}

export function getPlatformBrand() {
  try {
    const raw = localStorage.getItem(BRAND_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    if (!parsed || typeof parsed !== "object") return null;
    const safe = normalizePlatformBrand(parsed);
    if (raw !== JSON.stringify(safe)) {
      cachePlatformBrand(safe);
    }
    return safe;
  } catch {
    return null;
  }
}

export function setPlatformBrand(nextBrand) {
  return cachePlatformBrand(nextBrand);
}

export function clearPlatformBrand() {
  localStorage.removeItem(BRAND_KEY);
}

export async function fetchPlatformBrand() {
  const brand = normalizePlatformBrand(await apiGet("/platform/brand"));
  return cachePlatformBrand(brand);
}

export async function updatePlatformBrand(nextBrand) {
  const safePayload = normalizePlatformBrand(nextBrand);
  const response = await apiPut("/platform/brand", safePayload);
  const brand = normalizePlatformBrand(response?.brand || response || safePayload);
  return cachePlatformBrand(brand);
}

export const saveBrand = updatePlatformBrand;

export async function bootstrapPlatformBrand() {
  try {
    return await fetchPlatformBrand();
  } catch {
    const cached = getPlatformBrand();
    if (cached) return cached;
    return cachePlatformBrand(DEFAULT_PLATFORM_BRAND);
  }
}
